<div class="flex flex-wrap -mx-2 overflow-hidden">
  <div class="flex-none w-full px-4 flex flex-col h-full overflow-hidden">
    <ngx-treeview
        #treeviewComponent
        class="flex flex-col h-full w-full overflow-hidden"
        [tab]="'job department'"
        [config]="jobDepartmentConfig"
        [items]="jobDepartmentList"
        [itemTemplate]="itemTemplate"
        (filterChange)="onFilterChange($event)"
    ></ngx-treeview>
  </div>
</div>
<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand"
             let-onCheckedChange="onCheckedChange">
  <div class="ngx-treeview-row-item row-item">
    <fa-icon
      *ngIf="item.children"
      (click)="onCollapseExpand()"
      aria-hidden="true"
      class="si-treeview-icon"
      [fixedWidth]="true"
      [icon]="item.collapsed ? ['fas', 'caret-right'] : ['fas', 'caret-down']"
    ></fa-icon>
    <mat-checkbox
      class="flex-1"
      [(ngModel)]="item.checked"
      [disabled]="item.disabled || disabled"
      [indeterminate]="false"
      (ngModelChange)="onCheckedChange();jobFilterChange(item);"
    >
      <p class="ngx-treeview-row-item-text three-line-wrap mb-0">
        <span [matTooltip]="item.text">{{item.text}}</span>
        <span *ngIf="!item.children && item.value > 1"
              [matBadge]="item.value"
              class="job-department-badge inline-block align-text-bottom"
              matBadgeSize="small"
              matBadgeOverlap="false"
              matTooltip="Click to find all the departments with this responsibility"
              matTooltipPosition="right"
              (click)="filterChange(item.text)"
        ></span>
      </p>
    </mat-checkbox>
  </div>
</ng-template>
